export const campaignPremiumTypes = {
  coin: 'Seedz',
  storesOnline: 'Cupons e Ofertas Lojas Online',
  voucherProducts: 'Produtos',
  voucher: 'Desconto'
}

export const subscriptions = {
  allClients: 'Toda a base Seedz',
  //segmentation: 'Segmentação',
  allPreviousClients: 'Todos os clientes anteriores das empresas',
  specificClients: 'Clientes específicos'
}

export const subscriptionTypes = {
  automatic: 'Automático',
  manual: 'Manual'
}

export const registrationRoutines = {
  fixed: 'Fixo',
  floating: 'Flutuante'
}

export const premiumTypes = {
  unique: 'Única',
  proportional: 'Proporcional'
}

export const discountType = {
  fix: 'Fixo', 
  progressive: 'Progressivo'
}

export const goalType = {
  minimumValue: "Valor de compra (R$)"
}
